import { server_connection } from 'config';
import { getCompanyCalendarCourseEnrollmentData } from './courseEnrollment.actions';
import * as UserActions from '../../../../../auth/store/actions/index';
import history from 'history.js';
import store from 'store';

export const GET_ENROLLMENT_COURSE_LIST = '[ENROLLMENT APP] GET ENROLLMENT COURSE LIST';
export const SET_SEARCH_TEXT = '[ENROLLMENT APP] SET SEARCH TEXT';
export const GET_MAJOR_LIST = '[ENROLLMENT APP] GET MAJOR LIST';
export const SET_MAJOR_FILTER = '[ENROLLMENT APP] SET MAJOR FILTER';
export const SET_POPOVER_ANCHOR = '[ENROLLMENT APP] SET POPOVER ANCHOR';
export const SUBMIT_STUDENT_ENROLLMENT = '[ENROLLMENT APP] SUBMIT STUDENT ENROLLMENT';
export const REMOVE_STUDENT_ENROLLMENT = '[ENROLLMENT APP] REMOVE STUDENT ENROLLMENT';

export function getEnrollmentCourseList(student_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/get_course_list/' + student_id)
            .then((response) => response.json())
            .then((courseList) => {
                dispatch({
                    type: GET_ENROLLMENT_COURSE_LIST,
                    payload: courseList,
                });
            });
    }
}

export function setSearchText(searchText) {
    return (dispatch) => {
        dispatch({
            type: SET_SEARCH_TEXT,
            payload: searchText
        })
    }
}

export function getMajorList() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        fetch(server_connection + '/major/list/' + auth_id)
            .then((response) => response.json())
            .then((majorList) => {
                dispatch({
                    type: GET_MAJOR_LIST,
                    payload: majorList,
                });
            });
    }
}

export function setMajorFilter(majorFilter) {
    return (dispatch) => {
        dispatch({
            type: SET_MAJOR_FILTER,
            payload: majorFilter
        })
    }
}

export function setCoursePopoverAnchor(company_calendar_course_id, anchor) {
    return (dispatch) => {
        dispatch({
            type: SET_POPOVER_ANCHOR,
            payload: { company_calendar_course_id, anchor }
        })
    }
}

export function submitStudentEnrollment(student_id, company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/submit_student_enrollment',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_id, company_calendar_course_id })
            })
            .then((response) => response.json())
            .then((response) => {
                const company_course_student_rel_id = response.company_course_student_rel_id;

                dispatch({
                    type: SUBMIT_STUDENT_ENROLLMENT,
                    payload: { company_calendar_course_id, company_course_student_rel_id }
                });
                Promise.all([
                    dispatch(getCompanyCalendarCourseEnrollmentData(company_calendar_course_id, student_id)),
                    dispatch(UserActions.updateStudentUserCourses(student_id))
                ])
            });
    }
}

export function removeStudentEnrollment(student_id, company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/enrollment/remove_student_enrollment',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_id, company_calendar_course_id })
            })
            .then((response) => response.json())
            .then((response) => {
                dispatch({
                    type: REMOVE_STUDENT_ENROLLMENT,
                    payload: { company_calendar_course_id }
                });
                Promise.all([
                    dispatch(getCompanyCalendarCourseEnrollmentData(company_calendar_course_id, student_id)),
                    dispatch(UserActions.updateStudentUserCourses(student_id))
                ])
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/enrollment/store/actions/enrollment.actions.js